import { IRoutesDefined } from "@/api_framework/api_modals/Routers";

export const SLOTS_TABS: IRoutesDefined = {
  AVAILABLE_SLOTS: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "AVAILABLE_SLOTS",
    path: "available-slots",
    title: "available_slots",
    RBACDisplayName: "BOOK_APPOINTMENT",
    RBACDescription: "Book Appointment for customer and it's pet.",
    url: "/app/slots/available-slots",
    description: "All the available slots as per the filters",
  },
  AVAILABLE_SLOTS_RESCHEDULE: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "AVAILABLE_SLOTS_RESCHEDULE",
    path: "available-slots",
    title: "available_slots",
    isVirtual: true,
    RBACDisplayName: "BOOK_APPOINTMENT_RESCHEDULE",
    RBACDescription: "Edit / Reschedule Appointments for customer and it's pet.",
    url: "/app/slots/available-slots",
    description: "All the available slots as per the filters",
  },
  ALLOW_BOOKING_MANUAL_REFUND: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "ALLOW_BOOKING_MANUAL_REFUND",
    path: "allow_booking_manual_refund",
    title: "allow-manual-refund",
    isVirtual: true,
    RBACDisplayName: "ALLOW_BOOKING_MANUAL_REFUND",
    RBACDescription: "Allow booking refund",
    url: "/app/slots/allow_booking_manual_refund",
    description: "All the available slots as per the filters",
  },
  ALLOW_VC_IN_BOOKINGS: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "ALLOW_VC_IN_BOOKINGS",
    path: "allow_vc_in_bookings",
    title: "allow-vc-in-bookings",
    isVirtual: true,
    RBACDisplayName: "ALLOW_VC_BOOKINGS",
    RBACDescription: "Allow VC bookings",
    url: "/app/slots/allow_vc_in_bookings",
    description: "Allow video consultation bookings",
  },
  FRONT_DESK_OVERBOOKING: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "FRONT_DESK_OVERBOOKING",
    path: "front-desk-overbooking",
    title: "front-desk-overbooking",
    isVirtual: true,
    RBACDisplayName: "FRONT_DESK_OVERBOOKING",
    RBACDescription: "Front desk books appointments directly as overbookings (no slot selection).",
    url: "/app/slots/front-desk-overbooking",
    description: "Front desk direct overbooking flow on book appointment page",
  },
  AHS_BOOKING_LINK: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "AHS_BOOKING_LINK",
    path: "ahs-booking-link",
    title: "ahs-booking-link",
    isVirtual: true,
    RBACDisplayName: "AHS_BOOKING_LINK",
    RBACDescription: "Send the At Home Service booking link to eligible repeat AHS customers instead of booking a slot.",
    url: "/app/slots/ahs-booking-link",
    description: "AHS booking link card on book appointment page",
  },
  AVAILABLE_SLOTS_CANCELATION: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "AVAILABLE_SLOTS_CANCELATION",
    path: "available-slots",
    title: "available_slots",
    isVirtual: true,
    RBACDisplayName: "APPOINTMENT_CANCELATION",
    RBACDescription: "Cancel Appointments for customer and it's pet.",
    url: "/app/slots/available-slots",
    description: "All the available slots as per the filters",
  },
  BOOKED_SLOTS: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "BOOKED_SLOTS",
    path: "booked-slots",
    title: "booked_slots",
    RBACDisplayName: "BOOKED_SLOTS_TAB",
    RBACDescription: "Check Booked Slots on book appointment page",
    url: "/app/slots/booked-slots",
    description: "All the booked slots s per the filters",
  },
  OVERBOOKING_SLOTS: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "OVERBOOKING_SLOTS",
    path: "overbooking",
    title: "overbooking",
    RBACDisplayName: "OVERBOOKING_SLOTS_TAB",
    RBACDescription: "Check Overbooking Slots on book appointment page",
    url: "/app/slots/overbooking",
    description: "All the Overbooking slots as per the filters",
  },
  EDIT_BOOKING_COMMENT_PERMISION: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "EDIT_BOOKING_COMMENT_PERMISION",
    path: "edit-booking-permision",
    title: "Edit booking comment",
    isVirtual: true,
    RBACDisplayName: "EDIT_BOOKING_COMMENT_PERMISION",
    RBACDescription: "Edit Appointments for customer and it's pet.",
    url: "/app/slots/edit-booking-permision",
    description: "All the available slots as per the filters",
  },
};

export const SLOTS_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  BOOKING_CONFIRMATION: {
    id: "BOOKING_CONFIRMATION", // Find Nearby Clinic
    title: "booking_confirmation",
    icon: "BsCalendar2Check",
    path: "booking-confirmation",
    RBACDisplayName: "BOOKING_CONFIRMATION",
    RBACDescription: "Access to booking specific details on booking confirmation page.",
    url: "/app/slots/booking-confirmation",
    children: {},
  },
};

